import Konva from 'konva';

class Configurator{

	constructor(settings) {
		this.hasDifferentHeights = true;
		this.settings = settings;
		this.tarpMaxSize = 550;
		this.imagesUrl = '../app/themes/kampa/dist/images/configurator/';
		this.minOffsetFromSide = 100;
		this.sides = {
			top : {
				key : 'top',
				value : 'none',
				space : 300,
			},
			left : {
				key : 'left',
				value : 'none',
				space : 300,
			},
			right : {
				key : 'right',
				value : 'none',
				space : 300,
			},
			bottom : {
				key : 'bottom',
				value : 'none',
				space : 300,
			},
		};
		this.eyeletsCenter = {
			value : 'none',
			space : 300,
		}
		this.errors = [];

		this.mobileLastCenter = null;
		this.mobileLastDist = 0;
	}

	init(cont){
		var positionInfo = cont.getBoundingClientRect();
		this.canvasHeight = positionInfo.height;
		this.canvasWidth = positionInfo.width;
		let self = this;

		this.tarpMaxSize = 0.8 * Math.min(this.canvasWidth,this.canvasHeight);


		this.stage = new Konva.Stage({
			container: 'configurator-container',
			width: this.canvasWidth,
			height: this.canvasHeight,
			draggable: true,
		});

		// Layers
		this.tarpLayer = new Konva.Layer();
		this.dimensionsLayer = new Konva.Layer();

		// Tarp
		this.tarp = new Konva.Line({
			points: [0,0,200,0,200,200,0,200],
			fill: '#00D2FF',
			strokeWidth: 0,
			closed: true,
			//shadowColor: 'black',
			//shadowBlur: 10,
			shadowOffset: { x: 0, y: 0 },
			shadowOpacity: 0.2,
		});

		this.tarpLayer.add(this.tarp);



		//inner crop group
		this.innerCropGroup = new Konva.Group({
			clipFunc: function(ctx){
				var polygon = self.tarp.points();
				ctx.beginPath();
				ctx.moveTo(polygon[0], polygon[1]);
				for(var item = 2; item < polygon.length-1; item += 2 ){
					ctx.lineTo( polygon[item] , polygon[item+1] )
				}
				ctx.closePath();
			},
		});
		this.tarpLayer.add(this.innerCropGroup);

		// Extras Groups
		this.extrasGroups = {
			top : new Konva.Group(),
			right : new Konva.Group(),
			bottom : new Konva.Group(),
			left : new Konva.Group(),
		}

		// Eyelets center group
		this.eyeletsCenterGroup = new Konva.Group();

		// Door
		this.doorPos = {x: 0, y: 0};
		this.doorWidth = 0;
		this.doorHeight = 0;
		this.doorOffset = 10;
		this.doorWindow = false;
		this.door = new Konva.Group({
			draggable: true,
		});

		this.door.on('dragmove', function (e) {
			var bBox = this.getClientRect({relativeTo: self.tarpLayer});
			var posX = this.x();

			if(bBox.x < self.minOffsetFromSide || bBox.x + bBox.width  > self.tarpWidth - self.minOffsetFromSide){
				posX = self.doorPos.x;
			}

			this.x(Math.round(posX));
			this.y(self.doorPos.y)

			self.doorPos = {
				x: this.x(),
				y: this.y(),
			}

			let newBBox = this.getClientRect({relativeTo: self.tarpLayer});
			let doorData = {
				width: self.doorWidth,
				height: self.doorHeight,
				offset: newBBox.x,
			};
			const event = new CustomEvent('configurator_door_moved', { detail: doorData});

			self.doorOffset = doorData.offset;

			window.dispatchEvent(event);

			self.checkAllCollisions();
		});

		/*this.door.on('dragend', function () {
			self.updateSidesExtras();
		});*/

		this.door.on('mouseenter', function () {
			self.stage.container().style.cursor = 'move';
		});
		this.door.on('mouseleave', function () {
			self.stage.container().style.cursor = 'default';
		});

		// Windows
		this.windowsData = {};
		this.windows = new Konva.Group();
		this.tarpLayer.add(this.windows);

		// Cuts
		this.cutsData = {};
		this.cuts = new Konva.Group();
		this.innerCropGroup.add(this.cuts);

		/**
		 * Dirt lap
		 */
		this.hasDirtLap = false;
		this.dirtLap = new Konva.Group();

		/**
		 * Roll Belts
		 */
		this.hasRollBelts = false;
		this.rollBeltsGroup = new Konva.Group();

		/**
		 * Hit boxes
		 */
		this.hitBoxesGroup = new Konva.Group({
			x: 0,
			y: 0,
		});

		/**
		 * Dimensions
		 */
		this.tarpDimensions = new Konva.Group();
		this.dimensionsLayer.add(this.tarpDimensions);
		this.slant = 'top';

		// add the layer to the stage
		this.stage.add(this.tarpLayer);
		this.stage.add(this.dimensionsLayer);

		this.allowStageZoom();
	}

	setTarpSize(width, heightLeft, heightRight, slant){
		this.tarpWidth = width;
		this.tarpHeightLeft = heightLeft;
		this.tarpHeightRight = heightRight;
		this.slant = slant;

		let height = Math.max(heightLeft,heightRight);
		this.tarpHeight = height;

		let scale = this.tarpMaxSize / Math.max(width,height);

		if(this.slant == 'top'){
			this.tarp.points([0,height-heightLeft, width,height-heightRight, width,height, 0,height]);
		} else {
			this.tarp.points([0,0, width,0, width,heightRight, 0,heightLeft]);
		}

		this.tarp.shadowBlur(10/scale);
		this.tarpLayer.x((this.canvasWidth - width * scale) / 2);
		this.tarpLayer.y((this.canvasHeight - height * scale) / 2);
		this.tarpLayer.scale({ x: scale, y: scale});

		this.updateHitBoxes();
		this.updateTarpDimensions();
		this.updateCuts();
		this.updateSidesExtras();
		this.updateEyeletsCenter();
		this.updateDoor();
		this.updateWindows();
		this.updateDirtLap();
		this.updateRollBelts();
		this.updateRail();
	}

	setTarpColor(color){
		this.tarp.fill(color);
		this.updateDirtLap();

		let doorBelts = this.stage.find('#door_belt');
		if(doorBelts.length){
			doorBelts.forEach(function(el){
				el.fill(color);
			});
		}
	}

	setSides(side, value, space){
		this.sides[side].value = value;
		this.sides[side].space = space;
	}

	addDoor(width, height, offset, door_window = false, door_window_height = 0){
		this.deleteDoor();
		this.doorWidth = width;
		this.doorHeight = height;
		this.doorOffset = offset;
		this.doorWindow = door_window;
		this.doorWindowHeight = door_window_height;
		let self = this;
		let windowOffset = 20;

		if(width > 0 && height > 0){
			let lineLeft = new Konva.Rect({
				x: 0,
				y: 0,
				width: 5,
				height: height,
				fill: '#222222',
			});

			let lineRight = new Konva.Rect({
				x: width-5,
				y: 0,
				width: 5,
				height: height,
				fill: '#222222',
			});

			let rect = new Konva.Rect({
				x: 0,
				y: 0,
				width: width,
				height: height,
				name: 'doorBackground collisionFill',
				//fill: this.tarp.fill(),
			});

			this.door.add(rect);
			this.door.add(lineLeft);
			this.door.add(lineRight);

			if(door_window && door_window_height && door_window_height <= height - (2 * windowOffset)){
				let rectWindow = new Konva.Rect({
					x: windowOffset + 5,
					y: windowOffset,
					width: width - (2 * windowOffset) - 10,
					height: door_window_height,
					fill: '#e4f8ff',
					name: 'doorWindow',
				});
				this.door.add(rectWindow);
			}

			let element = this.getExtrasElement('roll_belt');
			let beltsWidth = width - 100;
			let elementsCount = Math.ceil( beltsWidth / 1000);
			elementsCount = (elementsCount < 2) ? 2 : elementsCount;
			let elementsGap = (beltsWidth - element.width) / (elementsCount-1);

			let imageObj = new Image();
			imageObj.crossOrigin = 'anonymous';
			imageObj.onload = function () {
				for(var i = 0; i < elementsCount; i++){
					var node = new Konva.Image({
						width: element.width,
						height: element.height,
						image: imageObj,
					});

					node.x( i * elementsGap + 50 );

					self.door.add(node);
				}
			};
			imageObj.src = self.settings.images['roll_belt'];

			this.updateDoor();

			this.innerCropGroup.add(this.door);
		}
	}

	deleteDoor(){
		this.door.remove();
		this.door.destroyChildren();
		this.updateSidesExtras();
		this.checkAllCollisions();
	}

	updateDoor(){
		this.door.y(this.tarpHeight - this.doorHeight);
		this.door.x(this.doorOffset);
		this.doorPos = {
			x: this.door.x(),
			y: this.door.y(),
		};
		this.updateSidesExtras();
		this.checkAllCollisions();
	}

	addWindow(uid, width, height, offsetLeft, offsetBottom){
		if(width && height && offsetLeft && offsetBottom){
			this.deleteWindow(uid);
			let self = this;

			this.windowsData[uid] = {
				uid: uid,
				width: width,
				height: height,
				offsetLeft: offsetLeft,
				offsetBottom: offsetBottom,
			};

			let rect = new Konva.Rect({
				x: offsetLeft,
				y: self.tarpHeight - offsetBottom - height,
				width: width,
				height: height,
				fill: '#e4f8ff',
				id: uid,
				draggable: true, //TODO
				name: 'window collisionFill',
			});

			rect.on('dragmove', function (e) {
				let newBBox = this.getClientRect({relativeTo: self.tarpLayer});
				let windowData = {
					uid: uid,
					width: width,
					height: height,
					offsetLeft: newBBox.x,
					offsetBottom: self.tarpHeight - height - newBBox.y,
				};
				const event = new CustomEvent('configurator_window_moved', { detail: windowData});

				self.windowsData[uid] = windowData;
				window.dispatchEvent(event);

				self.checkAllCollisions();
			});

			rect.on('mouseenter', function () {
				self.stage.container().style.cursor = 'move';
			});
			rect.on('mouseleave', function () {
				self.stage.container().style.cursor = 'default';
			});

			this.windows.add(rect);
			this.checkAllCollisions();
		}
		else{
			this.deleteWindow(uid);
		}
	}

	updateWindows(){
		let self = this;
		for (const [uid,data] of Object.entries(this.windowsData)) {
			self.addWindow(uid, data.width, data.height, data.offsetLeft, data.offsetBottom);
		}
		this.checkAllCollisions();
	}

	deleteWindow(uid){
		let elems = this.stage.find('#'+uid);
		if(elems.length){
			elems[0].destroy();
		}

		delete this.windowsData[uid];

		this.checkAllCollisions();
	}

	addCut(uid, width, height, corner, updateSides = true){
		if(width && height && corner){
			this.deleteCut(uid,false);
			let self = this;
			let x = 0;
			let y = 0;
			let h = height;
			let w  = width;

			if(corner == 'lt'){
				if(this.tarpHeightLeft < this.tarpHeightRight && this.slant == 'top'){
					let slantY = this.getTarpSlantY(width);
					y = slantY;
				}
			}
			else if(corner == 'rt'){
				x = self.tarpWidth - width;

				if(this.tarpHeightLeft > this.tarpHeightRight && this.slant == 'top'){
					let slantY = this.getTarpSlantY(x);
					y = slantY;
				}
			}
			else if(corner == 'lb'){
				y = self.tarpHeight - height;

				if(this.tarpHeightLeft < this.tarpHeightRight && this.slant == 'bottom'){
					let slantY = this.getTarpSlantY(width);
					y -= slantY;
				}

			}
			else if(corner == 'rb'){
				x = self.tarpWidth - width;
				y = self.tarpHeight - height;

				if(this.tarpHeightLeft > this.tarpHeightRight && this.slant == 'bottom'){
					let slantY = this.getTarpSlantY(x);
					y -= slantY;
				}
			}

			this.cutsData[uid] = {
				width : width,
				height : height,
				corner : corner,
				x: x,
				y : y,
			}

			let shape = new Konva.Rect({
				x: x,
				y: y,
				width: w,
				height: h,
				fill: 'whitesmoke',
				id: uid,
			});

			self.cuts.add(shape);

			if(updateSides){
				this.updateSidesExtras();
			}

			this.updateDirtLap();
			this.updateRollBelts();
			this.checkAllCollisions();
		}
		else{
			this.deleteCut(uid);
		}
	}

	getCutByCorner(corner){
		for (const [uid,data] of Object.entries(this.cutsData)) {
			if(data.corner == corner){
				data.uid = uid;
				return data;
			}
		}

		return null;
	}

	updateCuts(){
		let self = this;
		for (const [uid,data] of Object.entries(this.cutsData)) {
			self.addCut(uid, data.width, data.height, data.corner,false);
		}
		this.updateSidesExtras();
		this.updateDirtLap();
		this.updateRollBelts();
		this.checkAllCollisions();
	}

	deleteCut(uid,updateSides = true){
		let elems = this.stage.find('#'+uid);
		if(elems.length){
			elems[0].destroy();
		}
		delete this.cutsData[uid];

		if(updateSides){
			this.updateSidesExtras();
		}

		this.updateDirtLap();
		this.updateRollBelts();
	}

	updateSidesExtras(){
		let self = this;

		let cutLT = self.getCutByCorner('lt');
		let cutRT = self.getCutByCorner('rt');
		let cutLB = self.getCutByCorner('lb');
		let cutRB = self.getCutByCorner('rb');

		for (const [side, sideData] of Object.entries(this.sides)) {

			let group = new Konva.Group();
			self.extrasGroups[side].destroy();
			self.extrasGroups[side] = group;

			let heightDiff = self.getTarpHeightDiff();
			let slantRotation = Math.atan(heightDiff / self.tarpWidth) * 180 / Math.PI;
			let slantLength = self.getTarpSlantLength();

			if(sideData.value == 'roll'){
				let element = self.getExtrasElement('roll');
				let elementDouble = self.getExtrasElement('roll_double');
				let startX = elementDouble.offsetFromSide;
				let startY = -element.height * 0.4;
				let sideLength = self.tarpWidth - 2 * elementDouble.offsetFromSide;

				if(cutLT){
					startX += cutLT.width;
					sideLength -= cutLT.width;
				}
				if(cutRT){
					sideLength -= cutRT.width;
				}

				let elementsCount = Math.ceil((sideLength - 2 * (elementDouble.width + sideData.space)) / sideData.space);
				elementsCount = (elementsCount < 2) ? 2 : elementsCount;
				let elementsGap = (sideLength-element.width) / (elementsCount-1);

				group.x(startX);
				group.y(startY);

				let imageDoubleObj = new Image();
				imageDoubleObj.crossOrigin = 'anonymous';
				imageDoubleObj.onload = function () {
					var node = new Konva.Image({
						width: elementDouble.width,
						height: elementDouble.height,
						image: imageDoubleObj,
					});
					var n1 = node.clone({x: 0});
					var n2 = node.clone({x: sideLength - elementDouble.width});

					group.add(n1);
					group.add(n2);
				};
				imageDoubleObj.src = self.settings.images[elementDouble.image];

				let imageObj = new Image();
				imageObj.crossOrigin = 'anonymous';
				imageObj.onload = function () {
					for(var i = 1; i < elementsCount - 1; i++){
						var x = i * elementsGap;
						var node = new Konva.Image({
							width: element.width,
							height: element.height,
							image: imageObj,
							x: x,
						});

						group.add(node);
					}
				};
				imageObj.src = self.settings.images[element.image];

				self.tarpLayer.add(group);
				group.zIndex(2);

			}
			else if(sideData.value == 'circle'){
				let element = self.getExtrasElement('circle');
				let startX = element.offsetFromSide;
				let startY = -element.height * 0.87;
				let sideLength = self.tarpWidth - 2 * element.offsetFromSide;

				if(cutLT){
					startX += cutLT.width;
					sideLength -= cutLT.width;
				}
				if(cutRT){
					sideLength -= cutRT.width;
				}

				let elementsCount = Math.ceil((sideLength - 2 * (element.width + sideData.space)) / sideData.space);
				elementsCount = (elementsCount < 2) ? 2 : elementsCount;
				let elementsGap = (sideLength-element.width) / (elementsCount-1);

				group.x(startX);
				group.y(startY);

				let imageObj = new Image();
				imageObj.crossOrigin = 'anonymous';
				imageObj.onload = function () {
					for(var i = 0; i < elementsCount; i++){
						var x = i * elementsGap;
						var node = new Konva.Image({
							width: element.width,
							height: element.height,
							image: imageObj,
							x: x,
						});

						group.add(node);
					}
				};
				imageObj.src = self.settings.images[element.image];

				self.tarpLayer.add(group);
				group.zIndex(1);
			}
			else{
				let element = self.getExtrasElement(sideData.value);

				if(typeof element === 'undefined'){
					continue;
				}

				let slantSideLength = slantLength - 2 * element.offsetFromSide;
				let slantOffsetFromSide = self.getTarpSlantY(element.offsetFromSide);

				if(element.type == 'side_image'){

					let sideLength = 0;
					let startX = element.offsetFromSide;
					let startY = element.offsetFromSide;
					let rotation = 0;

					if(side == 'top'){

						if(heightDiff && self.slant == 'top'){
							sideLength = slantSideLength;
							rotation = slantRotation;

							if(self.tarpHeightLeft < self.tarpHeightRight){
								startY += heightDiff;
								rotation *= -1;

								if(cutLT){
									let _diff = self.getTarpSlantY(cutLT.width);
									let _length = (cutLT.width / self.tarpWidth) * slantLength;
									sideLength -= _length;
									startX += cutLT.width;
									startY -= heightDiff - _diff;
								}

								if(cutRT){
									let _length = (cutRT.width / self.tarpWidth) * slantLength;
									sideLength -= _length + element.offsetFromSide;
								}
							}
							else{
								startY += slantOffsetFromSide + (slantRotation * 0.8);
								startX += slantOffsetFromSide + (slantRotation / 1.5);

								if(slantRotation > 45){
									startX -= slantRotation / 3;
								}

								if(cutLT){
									let _diff = self.getTarpSlantY(cutLT.width);
									let _length = Math.sqrt( Math.pow(_diff,2) + Math.pow(cutLT.width,2) )
									sideLength -= _length;
									startX += cutLT.width;
									startY += _diff;
								}

								if(cutRT){
									let _diff = self.getTarpSlantY(cutRT.width);
									let _length = Math.sqrt( Math.pow(_diff,2) + Math.pow(cutRT.width,2) )
									sideLength -= _length + element.offsetFromSide;
								}
							}
						}
						else{
							sideLength = self.tarpWidth - 2 * element.offsetFromSide;

							if(cutLT){
								startX += cutLT.width;
								sideLength -= cutLT.width;
							}
							if(cutRT){
								sideLength -= cutRT.width;
							}
						}
					}
					else if(side == 'left'){
						sideLength = self.tarpHeightLeft - 2 * element.offsetFromSide;
						startY += self.slant == 'top' ? self.tarpHeight - self.tarpHeightLeft : 0;

						if(self.tarpHeightLeft > self.tarpHeightRight){
							if(cutLT){
								let _cutLength = cutLT.height;
								startY += _cutLength;
								sideLength -= _cutLength;
							}
							else{
								let _offset = slantOffsetFromSide + (slantRotation / 1.5);

								if(slantRotation > 45){
									_offset = slantOffsetFromSide + (slantRotation * 1.1);
								}
								startY += _offset;
								sideLength -= _offset;
							}

							if(cutLB){
								sideLength -= cutLB.height;
							}
						}
						else{
							if(cutLT){
								let _cutLength = self.slant == 'top' ? cutLT.height - (heightDiff - self.getTarpSlantY(cutLT.width)) : cutLT.height;
								startY += _cutLength;
								sideLength -= _cutLength;
							}

							if(cutLB){
								sideLength -= self.slant == 'top' ? cutLB.height : cutLB.height - self.getTarpSlantY(self.tarpWidth - cutLB.width);
							}
						}
					}
					else if(side == 'right'){
						let _slantOffsetFromSide = self.getTarpSlantY(this.tarpWidth - element.offsetFromSide)
						sideLength = self.tarpHeightRight - 2 * element.offsetFromSide;
						startX = self.tarpWidth - element.offsetFromSide - element.width;
						startY += self.slant == 'top' ? self.tarpHeight - self.tarpHeightRight : 0;

						if(self.tarpHeightLeft < self.tarpHeightRight){

							if(cutRT){
								let _cutLength = cutRT.height;
								startY += _cutLength;
								sideLength -= _cutLength;
							}
							else{
								let _offset = _slantOffsetFromSide + (slantRotation / 1.5);

								if(slantRotation > 45){
									_offset = _slantOffsetFromSide + (slantRotation * 1.1);
								}

								startY += _offset;
								sideLength -= _offset;
							}

							if(cutRB){
								sideLength -= cutRB.height;
							}
						}
						else{
							if(cutRT){
								let _cutLength = self.slant == 'top' ? cutRT.height - (heightDiff - self.getTarpSlantY(this.tarpWidth - cutRT.width)) : cutRT.height;
								startY += _cutLength;
								sideLength -= _cutLength;
							}

							if(cutRB){
								sideLength -= self.slant == 'top' ? cutRB.height : cutRB.height - self.getTarpSlantY(cutRB.width);
							}
						}
					}
					else if(side == 'bottom'){
						startY = self.tarpHeight - element.offsetFromSide - element.width;

						if(heightDiff && self.slant == 'bottom'){
							sideLength = slantSideLength;
							rotation = slantRotation;

							if(self.tarpHeightLeft < self.tarpHeightRight){
								startY -= heightDiff;

								if(cutLB){
									let _diff = self.getTarpSlantY(cutLB.width);
									let _length = (cutLB.width / self.tarpWidth) * slantLength;
									sideLength -= _length;
									startX += cutLB.width;
									startY += heightDiff - _diff;
								}

								if(cutRB){
									let _length = (cutRB.width / self.tarpWidth) * slantLength;
									sideLength -= _length + element.offsetFromSide;
								}
							}
							else{
								startY -= slantOffsetFromSide;// + (slantRotation * 0.8);
								//startX += slantOffsetFromSide + (slantRotation / 1.5);
								rotation *= -1;

								if(slantRotation > 45){
									//startX -= slantRotation / 3;
								}

								if(cutLB){
									let _diff = self.getTarpSlantY(cutLB.width);
									let _length = Math.sqrt( Math.pow(_diff,2) + Math.pow(cutLB.width,2) )
									sideLength -= _length;
									startX += cutLB.width;
									startY -= _diff;
								}

								if(cutRB){
									let _diff = self.getTarpSlantY(cutRB.width);
									let _length = Math.sqrt( Math.pow(_diff,2) + Math.pow(cutRB.width,2) )
									sideLength -= _length + element.offsetFromSide;
								}
							}
						}
						else{
							sideLength = self.tarpWidth - 2 * element.offsetFromSide;
							startY = self.tarpHeight - element.offsetFromSide - element.width;

							if(cutLB){
								startX += cutLB.width;
								sideLength -= cutLB.width;
							}
							if(cutRB){
								sideLength -= cutRB.width;
							}
						}
					}

					let elementsCount = Math.ceil(sideLength / sideData.space);
					elementsCount = (elementsCount < 2) ? 2 : elementsCount;
					let elementsGap = (sideLength-element.height) / (elementsCount-1);

					group.rotation(rotation);
					group.x(startX);
					group.y(startY);

					let excludes = ['none','keder','keder_rail'];
					let imageObj = new Image();
					imageObj.crossOrigin = 'anonymous';
					imageObj.onload = function () {
						for(var i = 0; i < elementsCount; i++){
							var node = new Konva.Image({
								width: element.width,
								height: element.height,
								image: imageObj,
							});

							if(side == 'top' || side == 'bottom'){
								node.x( i * elementsGap + element.height);
								node.rotation(90);

								if(!excludes.includes(self.sides.left.value) && i == 0 && ((side == 'top' && cutLT == null) || (side == 'bottom' && cutLB == null))){
									continue;
								}

								if(!excludes.includes(self.sides.left.value) && i == elementsCount - 1 && ((side == 'top' && cutRT == null) || (side == 'bottom' && cutRB == null))){
									continue;
								}
							}
							else{
								node.y( i * elementsGap );
							}


							group.add(node);

							/*if( self.door.children && self.haveIntersection(node,self.door)){
								node.destroy();
							}*/
						}
					};
					imageObj.src = self.settings.images[element.image];

					self.tarpLayer.add(group);
				}
				else if(element.type == 'long_image'){
					let startX = 0;
					let startY = 0;
					let rotation = 0;
					let sideLength = self.tarpWidth;

					if(side == 'top'){
						startY -= element.height - element.offsetFromSide;

						if(heightDiff && self.slant == 'top'){
							sideLength = slantLength;
							rotation = slantRotation;

							if(self.tarpHeightLeft < self.tarpHeightRight){
								rotation *= -1;
								startY += heightDiff;

								if(cutLT){
									let _diff = self.getTarpSlantY(cutLT.width);
									let _length =  (cutLT.width / self.tarpWidth) * slantLength;
									sideLength -= _length;
									startX += cutLT.width;
									startY -= heightDiff - _diff;
								}

								if(cutRT){
									let _length = (cutRT.width / self.tarpWidth) * slantLength;
									sideLength -= _length;
								}
							}
							else{

								if(cutLT){
									let _diff = self.getTarpSlantY(cutLT.width);
									let _length = (cutLT.width / self.tarpWidth) * slantLength;
									sideLength -= _length;
									startX += cutLT.width;
									startY += _diff;
								}

								if(cutRT){
									let _length = (cutRT.width / self.tarpWidth) * slantLength;
									sideLength -= _length;
								}
							}

							startX += rotation/2;
						}
						else{
							if(cutLT){
								startX += cutLT.width;
								sideLength -= cutLT.width;
							}
							if(cutRT){
								sideLength -= cutRT.width;
							}
						}
					}
					else if(side == 'left'){
						rotation = -90;
						startX -= element.height - element.offsetFromSide;
						startY += self.tarpHeight;
						sideLength = self.tarpHeightLeft;

						if(self.tarpHeightLeft < self.tarpHeightRight){

							if(self.slant == 'bottom'){
								startY -= heightDiff;
							}

							if(cutLT){
								let _cutLength = cutLT.height - (heightDiff - self.getTarpSlantY(cutLT.width));
								sideLength -= _cutLength;
							}
							if(cutLB){
								startY -= cutLB.height;
								sideLength -= cutLB.height;
							}
						}
						else{
							if(cutLT){
								let _cutLength = cutLT.height;
								sideLength -= _cutLength;
							}
							if(cutLB){
								startY -= cutLB.height;
								sideLength -= cutLB.height;
							}
						}
					}
					else if(side == 'right'){
						rotation = 90;
						startX += self.tarpWidth + element.height - element.offsetFromSide;
						startY += self.slant == 'top' ? self.tarpHeight - self.tarpHeightRight : 0;
						sideLength = self.tarpHeightRight;

						if(self.tarpHeightLeft < self.tarpHeightRight){
							if(cutRT){
								let _cutLength = cutRT.height;
								startY += _cutLength;
								sideLength -= _cutLength;
							}
							if(cutRB){
								sideLength -= cutRB.height;
							}
						}
						else{
							if(cutRT){
								let _cutLength = cutRT.height - (heightDiff - self.getTarpSlantY(self.tarpWidth - cutRT.width));
								startY += _cutLength;
								sideLength -= _cutLength;
							}
							if(cutRB){
								sideLength -= cutRB.height;
							}
						}
					}
					else if(side == 'bottom'){
						//rotation = 180;
						group.scaleY(-1);
						startY += self.tarpHeight + element.height - element.offsetFromSide;

						if(heightDiff && self.slant == 'bottom'){
							sideLength = slantLength;
							rotation -= slantRotation;

							if(self.tarpHeightLeft < self.tarpHeightRight){
								rotation *= -1;
								startY -= heightDiff;
								startX -= slantRotation;

								if(cutLB){
									let _diff = self.getTarpSlantY(cutLB.width);
									let _length =  (cutLB.width / self.tarpWidth) * slantLength;
									sideLength -= _length;
									startX += cutLB.width;
									startY += heightDiff - _diff;
								}

								if(cutRB){
									let _length = (cutRB.width / self.tarpWidth) * slantLength;
									sideLength -= _length;
								}
							}
							else{
								startX += slantRotation;
								startY -= slantRotation/2;

								if(cutLB){
									let _diff = self.getTarpSlantY(cutLB.width);
									let _length = (cutLB.width / self.tarpWidth) * slantLength;
									sideLength -= _length;
									startX += cutLB.width;
									startY -= _diff;
								}

								if(cutRB){
									let _length = (cutRB.width / self.tarpWidth) * slantLength;
									sideLength -= _length;
								}
							}
						}
						else{

							if(cutLB){
								startX += cutLB.width;
								sideLength -= cutLB.width;
							}
							if(cutRB){
								sideLength -= cutRB.width;
							}
						}
					}

					group.rotation(rotation);
					group.x(startX);
					group.y(startY);

					let imageObj = new Image();
					imageObj.crossOrigin = 'anonymous';
					imageObj.onload = function () {
						let scale = element.height / imageObj.height;
						let shape = new Konva.Rect({
							x: 0,
							y: 0,
							width: sideLength,
							height: element.height,
							fillPatternImage: imageObj,
							fillPatternRepeat: 'repeat-x',
							fillPatternScaleY: scale,
							fillPatternScaleX: scale,
						});

						group.add(shape);
					};
					imageObj.src = self.settings.images[element.image];

					self.tarpLayer.add(group);
				}
			}
		}

		this.updateEyeletsCenter();
	}

	/**
	 * Eyelets Center
	 */

	setEyeletsCenter(value, space, offset){
		this.eyeletsCenter.value = value;
		this.eyeletsCenter.space = space;
		this.eyeletsCenter.offset = offset;
	}

	updateEyeletsCenter(){
		this.eyeletsCenterGroup.destroy();
		let group = new Konva.Group();
		this.eyeletsCenterGroup = group;

		if(this.eyeletsCenter.value != 'none' && this.eyeletsCenter.space > 0 && this.eyeletsCenter.offset > 0){
			let element = this.getExtrasElement(this.eyeletsCenter.value);
			let offset = this.eyeletsCenter.offset;
			let startX = offset - (element.width / 2);
			let slantDiff = this.getTarpSlantY(startX + element.width);
			let length = this.tarpHeight - slantDiff - 2 * element.offsetFromSide;
			let startY = this.slant == 'top' ? slantDiff + element.offsetFromSide : element.offsetFromSide;

			let cutLT = this.getCutByCorner('lt');
			let cutRT = this.getCutByCorner('rt');
			let cutLB = this.getCutByCorner('lb');
			let cutRB = this.getCutByCorner('rb');

			if(this.sides.top.value != 'none'){
				startY += 100;
				length -= 100;
			}

			if(this.sides.bottom.value != 'none'){
				length -= 100;
			}

			if(cutLT && cutLT.width >= offset){
				if(this.tarpHeightLeft > this.tarpHeightRight){
					let _cutLength = cutLT.height - slantDiff;
					startY += this.slant == 'top' ? _cutLength : _cutLength + slantDiff;
					length -= this.slant == 'top' ? _cutLength : _cutLength + slantDiff;
				}
				else{
					let _cutLength = cutLT.height - slantDiff + this.getTarpSlantY(cutLT.width);
					startY += this.slant == 'top' ? _cutLength : cutLT.height;
					length -= this.slant == 'top' ? _cutLength : cutLT.height;
				}

				if(this.sides.top.value != 'none'){
					startY -= 100;
					length += 100;
				}
			}
			if(cutLB && cutLB.width >= offset){
				length -= cutLB.height;

				if(this.sides.bottom.value != 'none'){
					length += 100;
				}
			}
			if(cutRT && this.tarpWidth - cutRT.width <= offset){

				if(this.tarpHeightLeft > this.tarpHeightRight){
					let _cutLength = cutRT.height - slantDiff + this.getTarpSlantY(this.tarpWidth - cutRT.width);
					startY += this.slant == 'top' ? _cutLength : cutRT.height;
					length -= this.slant == 'top' ? _cutLength : cutRT.height;
				}
				else{
					let _cutLength = cutRT.height - slantDiff;
					startY += this.slant == 'top' ? _cutLength : cutRT.height;
					length -= this.slant == 'top' ? _cutLength : _cutLength + slantDiff;
				}

				if(this.sides.top.value != 'none'){
					startY -= 100;
					length += 100;
				}
			}
			if(cutRB && this.tarpWidth - cutRB.width <= offset){
				length -= cutRB.height;

				if(this.sides.bottom.value != 'none'){
					length += 100;
				}
			}

			let elementsCount = Math.ceil(length / this.eyeletsCenter.space);
			elementsCount = (elementsCount < 2) ? 2 : elementsCount;
			let elementsGap = (length-element.height) / (elementsCount-1);

			group.x(startX);
			group.y(startY);

			let bg = new Konva.Rect({
				width: element.width,
				height: length,
			});
			group.add(bg);

			let imageObj = new Image();
			imageObj.crossOrigin = 'anonymous';
			imageObj.onload = function () {
				for(var i = 0; i < elementsCount; i++){
					var node = new Konva.Image({
						width: element.width,
						height: element.height,
						image: imageObj,
					});

					node.y( i * elementsGap );

					group.add(node);
				}
			};
			imageObj.src = this.settings.images[element.image];

			this.tarpLayer.add(group);
		}

		this.checkAllCollisions();
	}

	/**
	 * Roll belts
	 */
	addRollBelts(){
		this.hasRollBelts = true;
		let element = this.getExtrasElement('roll_belt');
		let length = this.tarpWidth - 2 * element.offsetFromSide;
		let heightDiff = this.getTarpHeightDiff();
		this.rollBeltsGroup.destroy();
		let startX = element.offsetFromSide;
		let startY = element.offsetFromSide + heightDiff;

		let cutLT = this.getCutByCorner('lt');
		let cutRT = this.getCutByCorner('rt');

		if(this.tarpHeightLeft > this.tarpHeightRight){
			if(cutRT){
				if(cutRT.height < 200){
					startY += cutRT.height;
				}
				else{
					length -= cutRT.width;
				}
			}

			if(cutLT){
				if(cutLT.height >= heightDiff + 100){
					startX += cutLT.width;
					length -= cutLT.width;
				}
			}
		}
		else{
			if(cutLT){
				if(cutLT.height < 200){
					startY += cutLT.height;
				}
				else{
					length -= cutLT.width;
					startX += cutLT.width;
				}
			}

			if(cutRT){
				if(cutRT.height >= heightDiff + 100){
					length -= cutRT.width;
				}
			}
		}

		let group = new Konva.Group({
			x: startX,
			y: startY,
			width: length,
			height: 100,
		});

		this.rollBeltsGroup = group;

		let elementsCount = Math.ceil(length / 1000);
			elementsCount = (elementsCount < 2) ? 2 : elementsCount;
		let elementsGap = (length-element.width) / (elementsCount-1);

		let bg = new Konva.Rect({
			x: 0,
			y: 0,
			height: element.height,
			width: length,
		});
		group.add(bg);

		let imageObj = new Image();
		imageObj.crossOrigin = 'anonymous';
		imageObj.onload = function () {
			for(var i = 0; i < elementsCount; i++){
				var node = new Konva.Image({
					width: element.width,
					height: element.height,
					image: imageObj,
				});

				node.x( i * elementsGap );

				group.add(node);
			}
		};
		imageObj.src = this.settings.images[element.image];

		this.tarpLayer.add(group);
		this.checkAllCollisions();
	}

	updateRollBelts(){
		if(this.hasRollBelts){
			this.removeRollBelts();
			this.addRollBelts();
		}
		this.checkAllCollisions();
	}

	removeRollBelts(){
		this.hasRollBelts = false;
		this.rollBeltsGroup.destroy();
		this.rollBeltsGroup = new Konva.Group();
		this.checkAllCollisions();
	}

	/**
	 * Rail
	 */
	setRail(holders, extraLenght = 0, curved = false){
		this.hasRail = true;
		this.railHolders = holders;
		this.railExtraLength = extraLenght;
		this.railCurved = curved;
		this.updateRail();
	}

	addRail(holders = 'none', extraLenght = 0, curved = false){
		let self = this;
		let element = this.getExtrasElement('rail');
		let width = this.tarpWidth + extraLenght;
		let railY = -element.height + element.offsetFromSide;
		let imageObj = new Image();
		imageObj.crossOrigin = 'anonymous';
		imageObj.onload = function () {
			let scale = element.height / imageObj.height;
			let shape = new Konva.Rect({
				x: 0,
				y: railY,
				width: width,
				height: element.height,
				fillPatternImage: imageObj,
				fillPatternRepeat: 'repeat-x',
				fillPatternScaleY: scale,
				fillPatternScaleX: scale,
				id: 'rail',
			});

			self.tarpLayer.add(shape);
			shape.zIndex(3);
		};
		imageObj.src = self.settings.images[element.image];

		if(holders == 'wall' || holders == 'ceiling'){
			let group = new Konva.Group({
				id: 'rail_holders',
			});
			let holderElement = this.getExtrasElement('rail_holder_'+holders);
			let sideLength = width - 2 * holderElement.offsetFromSide;
			let startX = holderElement.offsetFromSide;
			let startY = railY - (holderElement.height - element.height) + 1;
			let space = 800;

			let elementsCount = Math.ceil((sideLength - 2 * (holderElement.width + space)) / space);
			elementsCount = (elementsCount < 2) ? 2 : elementsCount;
			let elementsGap = (sideLength-holderElement.width) / (elementsCount-1);

			group.x(startX);
			group.y(startY);

			let imageObj = new Image();
			imageObj.crossOrigin = 'anonymous';
			imageObj.onload = function () {
				for(var i = 0; i < elementsCount; i++){
					var x = i * elementsGap;
					var node = new Konva.Image({
						width: holderElement.width,
						height: holderElement.height,
						image: imageObj,
						x: x,
					});

					group.add(node);
				}
			};
			imageObj.src = self.settings.images[holderElement.image];

			self.tarpLayer.add(group);
			group.zIndex(4);
		}
	}

	updateRail(){
		if(this.hasRail){
			this.removeRail();
			this.addRail(this.railHolders, this.railExtraLength, this.railCurved);
		}
	}

	removeRail(){
		this.hasRail = false;
		let rail = this.tarpLayer.findOne('#rail');
		let railHolders = this.tarpLayer.findOne('#rail_holders');

		if(rail){
			rail.destroy();
		}

		if(railHolders){
			railHolders.destroy();
		}
	}

	/**
	 * Steel rope
	 */
	addSteelRope(){
		if(!this.hasSteelRope){
			let self = this;
			this.hasSteelRope = true;
			let element = this.getExtrasElement('steel_rope');
			let sideLength = this.tarpWidth;

			let imageObj = new Image();
			imageObj.crossOrigin = 'anonymous';
			imageObj.onload = function () {
				let scale = element.height / imageObj.height;
				let shape = new Konva.Rect({
					x: 0,
					y: -element.height + element.offsetFromSide,
					width: sideLength,
					height: element.height,
					fillPatternImage: imageObj,
					fillPatternRepeat: 'repeat-x',
					fillPatternScaleY: scale,
					fillPatternScaleX: scale,
					id: 'steel_rope',
				});

				self.tarpLayer.add(shape);
				shape.zIndex(0);
			};
			imageObj.src = self.settings.images[element.image];
		}
	}

	updateSteelRope(){
		if(this.hasSteelRope){
			this.removeSteelRope();
			this.addSteelRope();
		}
	}

	removeSteelRope(){
		this.hasSteelRope = false;
		let steelRope = this.tarpLayer.findOne('#steel_rope');

		if(steelRope){
			steelRope.destroy();
		}
	}

	/**
	 * Helpers
	 */

	getTarpHeightDiff(){
		return Math.abs(this.tarpHeightLeft - this.tarpHeightRight)
	}

	getTarpSlantLength(){
		let heightDiff = this.getTarpHeightDiff();
		return Math.sqrt( Math.pow(heightDiff,2) + Math.pow(this.tarpWidth,2) );
	}

	getTarpSlantY(x){
		let slantLength = this.getTarpSlantLength();
		let slantPartLength = (x / this.tarpWidth) * slantLength;
		let width = x;

		if(this.tarpHeightLeft < this.tarpHeightRight){
			slantPartLength = slantLength - slantPartLength;
			width = this.tarpWidth - x;
		}

		return Math.sqrt( Math.pow(slantPartLength,2) - Math.pow(width,2));
	}

	getExtrasElement(element){
		let extrasElements = {
			round : {
				width : 27,
				height : 27,
				offsetFromSide : 12,
				type : 'side_image',
				image: 'eyelet_round',
			},
			oval : {
				width : 37,
				height : 60,
				offsetFromSide : 5,
				type : 'side_image',
				image: 'eyelet_oval',
			},
			rotating_lock : {
				width : 37,
				height : 60,
				offsetFromSide : 5,
				type : 'side_image',
				image: 'eyelet_rotating_lock',
			},
			plastic_rotating_lock : {
				width : 42,
				height : 60,
				offsetFromSide : 3,
				type : 'side_image',
				image: 'plastic_rotating_lock',
			},
			oval_small : {
				width : 29,
				height : 39,
				offsetFromSide : 11,
				type : 'side_image',
				image: 'eyelet_oval_small',
			},
			rotating_lock_small : {
				width : 29,
				height : 39,
				offsetFromSide : 11,
				type : 'side_image',
				image: 'eyelet_rotating_lock_small',
			},
			keder : {
				height : 35,
				offsetFromSide : 2,
				type : 'long_image',
				image: 'keder_pattern',
			},
			keder_rail : {
				height : 53,
				offsetFromSide : 2,
				type : 'long_image',
				image: 'keder_rail_pattern',
			},
			roll_belt : {
				width : 35,
				height : 149,
				offsetFromSide : 150,
				type : 'side_image',
				image: 'roll_belt',
			},
			roll : {
				width : 20,
				height : 70,
				offsetFromSide : 50,
				type : 'side_image',
				image: 'roll',
			},
			roll_double : {
				width : 59,
				height : 70,
				offsetFromSide : 50,
				type : 'side_image',
				image: 'roll_double',
			},
			circle : {
				width : 30,
				height : 94,
				offsetFromSide : 50,
				type : 'side_image',
				image: 'circle',
			},
			rail : {
				height : 45,
				offsetFromSide : -6,
				type : 'long_image',
				image: 'rail_pattern',
			},
			rail_holder_wall : {
				width : 60,
				height : 77,
				offsetFromSide : 50,
				type : 'side_image',
				image: 'rail_holder_wall',
			},
			rail_holder_ceiling : {
				width : 60,
				height : 53,
				offsetFromSide : 50,
				type : 'side_image',
				image: 'rail_holder_ceiling',
			},
			steel_rope : {
				height : 5,
				offsetFromSide : -72,
				type : 'long_image',
				image: 'steel_rope_pattern',
			},
		}

		return extrasElements[element];
	}

	/**
	 * Dirt Lap
	 */

	addDirtLap(){
		this.dirtLap.remove();
		let dirtLapHeight = 200;
		let width = this.tarpWidth;
		let x = 0;
		let y = this.tarpHeight;
		let cutLB = this.getCutByCorner('lb');
		let cutRB = this.getCutByCorner('rb');
		let heightDiff = this.getTarpHeightDiff();

		console.log(this.getTarpSlantY(100));

		if(cutLB){
			x += cutLB.width;
			width -= cutLB.width;
		}

		if(cutRB){
			width -= cutRB.width;
		}

		let rect = new Konva.Line({
			points: [0,0, width,0, width,dirtLapHeight, 0,dirtLapHeight],
			closed: true,
			fillLinearGradientStartPoint: {
				x: width/2,
				y: dirtLapHeight/2,
			},
			fillLinearGradientEndPoint: {
				x: width/2,
				y: dirtLapHeight+300,
			},
			fillLinearGradientColorStops: [0, this.tarp.fill(), 1, 'black'],
		});

		let line = new Konva.Line({
			points: [0,0, width, 0],
			stroke: 'gray',
			strokeWidth: 2,
		});

		if(heightDiff && this.slant == 'bottom'){
			y = this.tarpHeight - heightDiff;

			if(this.tarpHeightLeft < this.tarpHeightRight){
				var rY = heightDiff;

				if(cutLB) {
					let cutY = this.getTarpSlantY(cutLB.width);
					y = this.tarpHeight - cutY;
					rY = cutY;
				}

				if(cutRB){
					let cutY = this.getTarpSlantY(this.tarpWidth - cutRB.width);
					rY -= cutY;
				}

				line.points([0,0, width,rY]);
				rect.points([0,0, width,rY, width,rY+dirtLapHeight, 0,dirtLapHeight])
			}
			else{
				var lY = heightDiff;

				if(cutRB){
					let cutY = this.getTarpSlantY(this.tarpWidth - cutRB.width);
					y = this.tarpHeight - cutY;
					lY = cutY;
				}

				if(cutLB) {
					let cutY = this.getTarpSlantY(cutLB.width);
					lY -= cutY;
				}

				line.points([0,lY, width,0]);
				rect.points([0,lY, width,0, width,dirtLapHeight, 0,lY+dirtLapHeight])
			}
		}

		this.dirtLap = new Konva.Group({
			x: x,
			y: y,
			width: width,
			height: dirtLapHeight,
		});

		this.dirtLap.add(rect);
		this.dirtLap.add(line);
		this.tarpLayer.add(this.dirtLap);
		this.hasDirtLap = true;

		this.updateTarpDimensions();
	}

	updateDirtLap(){
		if(this.hasDirtLap){
			this.addDirtLap();
		}
	}

	removeDirtLap(){
		this.hasDirtLap = false;
		this.dirtLap.remove();

		this.updateTarpDimensions();
	}

	/**
	 * Hit Boxes
	 */
	updateHitBoxes(){
		let self = this;
		this.hitBoxesGroup.destroy();
		this.hitBoxesGroup = new Konva.Group();
		let heightDiff = this.getTarpHeightDiff();
		let hitBoxWidth = 99;
		let hitBoxDiff = this.getTarpSlantY(hitBoxWidth);

		for(var i = 0; i < Math.ceil(this.tarpWidth / hitBoxWidth); i++){
			let y = 0;

			if(heightDiff){

				if(self.tarpHeightLeft > self.tarpHeightRight){
					y = i * hitBoxDiff;
				}
				else{
					y = heightDiff - i * (heightDiff - hitBoxDiff);
				}
			}

			let hitBoxTop = new Konva.Rect({
				x: i * hitBoxWidth,
				y: y,
				width: hitBoxWidth,
				height: hitBoxWidth,
				fill: 'transparent',
				name: 'hitBoxTop',
			});
			self.hitBoxesGroup.add(hitBoxTop);
		}

		let hitBoxLeft = new Konva.Rect({
			x: 0,
			y: 0,
			width: hitBoxWidth,
			height: this.tarpHeight,
			fill: 'transparent',
			name: 'hitBoxLeft',
		});

		let hitBoxRight = new Konva.Rect({
			x: this.tarpWidth - hitBoxWidth,
			y: 0,
			width: hitBoxWidth,
			height: this.tarpHeight,
			fill: 'transparent',
			name: 'hitBoxRight',
		});

		let hitBoxBottom = new Konva.Rect({
			x: 0,
			y: this.tarpHeight - hitBoxWidth,
			width: this.tarpWidth,
			height: hitBoxWidth,
			fill: 'transparent',
			name: 'hitBoxBottom',
		});


		this.hitBoxesGroup.add(hitBoxLeft);
		this.hitBoxesGroup.add(hitBoxRight);
		this.hitBoxesGroup.add(hitBoxBottom);

		this.tarpLayer.add(this.hitBoxesGroup);
	}

	/**
	 * Collisions
	 */

	checkAllCollisions(){
		this.checkDoorCollision();
		this.checkWindowsCollisions();

		this.triggerErrorsUpdateEvent();
	}

	checkDoorCollision(){
		let res = this.checkCollision(this.door,'hitBoxBottom');
		let fillObj = this.door.findOne('.collisionFill');
		this.removeError('door');

		if(fillObj){
			if(res){
				fillObj.fill('#ff5761');
				this.addError('door');
			}
			else{
				fillObj.fill('transparent');
			}
		}
	}

	checkWindowsCollisions(){
		let self = this;
		self.removeError('windows');
		this.windows.children.forEach(function(el){
			let res = self.checkCollision(el);
			if(res){
				el.fill('#ff5761');
				self.addError('windows');
			}
			else{
				el.fill('#e4f8ff');
			}
		});
	}

	checkCollision(target, excludeName = ''){
		let self = this;
		let res = false;
		let elementsToCheck = [];

		if(!this.settings.hideDoorWindowCollission){
			elementsToCheck.push(this.door);
			elementsToCheck = elementsToCheck.concat(this.windows.children);
		}

		elementsToCheck.push(this.eyeletsCenterGroup);
		elementsToCheck = elementsToCheck.concat(this.cuts.children);
		elementsToCheck = elementsToCheck.concat(this.hitBoxesGroup.children);

		elementsToCheck.forEach(function(el){
			if(el !== target && !(excludeName !== '' && el.name().includes(excludeName)) ){
				if(self.haveIntersection(target,el)){
					res = true;
				}
			}
		});

		if(!res){
			res = !self.haveIntersection(target,this.tarp);
		}

		return res;
	}

	haveIntersection(shape1, shape2) {
		let r1 = shape1.getClientRect({relativeTo: this.tarpLayer});
		let r2 = shape2.getClientRect({relativeTo: this.tarpLayer});

		return !(
			r2.x > r1.x + r1.width ||
			r2.x + r2.width < r1.x ||
			r2.y > r1.y + r1.height ||
			r2.y + r2.height < r1.y
		);
    }

	/**
	 * Dimensions
	 */
	updateTarpDimensions(){
		this.tarpDimensions.destroyChildren();
		let tLRect = this.tarp.getClientRect({skipShadow: true, relativeTo: this.stage});
		let heightDiff = this.getTarpHeightDiff();

		let dimHeightLeft = this.getDimensionsLines(tLRect.height, ('B: '+this.tarpHeightLeft/10)+'cm', {
			x: tLRect.x - 32,
			y: tLRect.y,
		}, 'height_left', false, 1);
		let dimHeightRight = this.getDimensionsLines(tLRect.height, ('C: '+this.tarpHeightRight/10)+'cm', {
			x: tLRect.x + tLRect.width + 20,
			y: tLRect.y,
		}, 'height_right', false);
		let dimWidth = this.getDimensionsLines(tLRect.width, ('A: '+this.tarpWidth/10)+'cm', {
			x: tLRect.x,
			y: tLRect.y + tLRect.height + 20,
		}, 'width');

		if(this.hasDirtLap){
			dimWidth.y( dimWidth.y() + this.dirtLap.getClientRect().height );
		}

		if(heightDiff){
			let scale = tLRect.height / this.tarpHeight;

			if(this.tarpHeightLeft < this.tarpHeightRight){
				let length = scale * this.tarpHeightLeft;
				dimHeightLeft = this.getDimensionsLines(length, ('B: '+this.tarpHeightLeft/10)+'cm', {
					x: tLRect.x - 32,
					y: this.slant == 'top' ? tLRect.y + (heightDiff * scale) : tLRect.y,
				}, 'height_left', false, 1);
			}
			else{
				let length = scale * this.tarpHeightRight;
				dimHeightRight = this.getDimensionsLines(length, ('C: '+this.tarpHeightRight/10)+'cm', {
					x: tLRect.x + tLRect.width + 20,
					y: this.slant == 'top' ? tLRect.y + (heightDiff * scale) : tLRect.y,
				}, 'height_right', false);
			}
		}

		this.tarpDimensions.add(dimHeightLeft);
		this.tarpDimensions.add(dimWidth);
		if(this.hasDifferentHeights){
			this.tarpDimensions.add(dimHeightRight);
		}
	}

	getDimensionsLines(length, textLabel, newAtts = {}, clickName = '', horizontally = true, textPos = 2){
		let self = this;
		let linesGroup = new Konva.Group();
		let marker1 = new Konva.Line({
			points: [0,0,0,12],
			stroke: 'gray',
			strokeWidth: 1,
			lineCap: 'round',
			lineJoin: 'round',
		});
		let lineMiddle = new Konva.Line({
			points: [0,6,length,6],
			stroke: 'gray',
			strokeWidth: 1,
			lineCap: 'round',
			lineJoin: 'round',
		});
		let marker2 = new Konva.Line({
			points: [length,0,length,12],
			stroke: 'gray',
			strokeWidth: 1,
			lineCap: 'round',
			lineJoin: 'round',
		});
		let text = new Konva.Text({
			x: length / 2,
			y: 12,
			text: textLabel,
			fontSize: 16,
			fill: 'black',
		});

		if(horizontally){
			text.offsetX(text.width() / 2);
			if(textPos == 1){
				text.y(-16)
			}
		}
		else{
			marker1.points([0,0,12,0]);
			lineMiddle.points([6,0,6,length]);
			marker2.points([0,length,12,length]);
			text.y(length/2);

			if(textPos === 1){
				text.x(-1 * text.width());
			}
			else{
				text.x(12);
			}
			text.offsetY(text.height() / 2);
		}

		linesGroup.add(marker1);
		linesGroup.add(lineMiddle);
		linesGroup.add(marker2);
		linesGroup.add(text);

		if(clickName.length){
			text.on('mouseenter', function () {
				self.stage.container().style.cursor = 'pointer';
			});
			text.on('mouseleave', function () {
				self.stage.container().style.cursor = 'default';
			});
			text.on('click', function () {
				const event = new CustomEvent('configurator_dimension_click', { detail: {
					name: clickName,
				}});
				window.dispatchEvent(event);
			});
		}

		let copy = linesGroup.clone(newAtts);
		linesGroup.destroy();
		return copy;
	}

	/**
	 * Errors
	 */

	addError(key){
		this.removeError(key);
		this.errors.push(key);
	}

	removeError(key){
		const index = this.errors.indexOf(key);
		if (index > -1){
			this.errors.splice(index, 1);
		}
	}

	getErrors(){
		return this.errors;
	}

	triggerErrorsUpdateEvent(){
		let self = this;
		const event = new CustomEvent('configurator_errors_update', { detail: {
			errors: self.getErrors(),
		}});
		window.dispatchEvent(event);
	}

	/**
	 * Stage
	 */

	allowStageZoom(){

		/**
		 * Wheel zoom
		 */
		var scaleBy = 1.25;
		this.stage.on('wheel', (e) => {
			// stop default scrolling
			e.evt.preventDefault();

			var oldScale = this.stage.scaleX();
			var pointer = this.stage.getPointerPosition();

			var mousePointTo = {
				x: (pointer.x - this.stage.x()) / oldScale,
				y: (pointer.y - this.stage.y()) / oldScale,
			};

			// how to scale? Zoom in? Or zoom out?
			let direction = e.evt.deltaY > 0 ? -1 : 1;

			var newScale = direction > 0 ? oldScale * scaleBy : oldScale / scaleBy;

			this.stage.scale({ x: newScale, y: newScale });

			var newPos = {
				x: pointer.x - mousePointTo.x * newScale,
				y: pointer.y - mousePointTo.y * newScale,
			};
			this.stage.position(newPos);
		});

		/**
		 * Mobile pinch zoom
		 */

		this.stage.on('touchmove', (e) => {
			e.evt.preventDefault();
			var touch1 = e.evt.touches[0];
			var touch2 = e.evt.touches[1];

			if (touch1 && touch2) {
				this.stage.draggable(false);

				var p1 = {
					x: touch1.clientX,
					y: touch1.clientY,
				};
				var p2 = {
					x: touch2.clientX,
					y: touch2.clientY,
				};

				if (!this.mobileLastCenter) {
					this.mobileLastCenter = this.getCenter(p1, p2);
					return;
				}
				var newCenter = this.getCenter(p1, p2);

				var dist = this.getDistance(p1, p2);

				if (!this.mobileLastDist) {
					this.mobileLastDist = dist;
				}

				// local coordinates of center point
				var pointTo = {
					x: (newCenter.x - this.stage.x()) / this.stage.scaleX(),
					y: (newCenter.y - this.stage.y()) / this.stage.scaleX(),
				};

				var scale = this.stage.scaleX() * (dist / this.mobileLastDist);

				this.stage.scaleX(scale);
				this.stage.scaleY(scale);

				// calculate new position of the stage
				var dx = newCenter.x - this.mobileLastCenter.x;
				var dy = newCenter.y - this.mobileLastCenter.y;

				var newPos = {
					x: newCenter.x - pointTo.x * scale + dx,
					y: newCenter.y - pointTo.y * scale + dy,
				};


				this.stage.position(newPos);

				this.mobileLastDist = dist;
				this.mobileLastCenter = newCenter;
			}
		});

		this.stage.on('touchend', (e) => {
			this.mobileLastDist = 0;
			this.mobileLastCenter = null;
			this.stage.draggable(true);
		});
	}

	getCenter(p1, p2) {
		return {
			x: (p1.x + p2.x) / 2,
			y: (p1.y + p2.y) / 2,
		};
    }

	getDistance(p1, p2) {
		return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
    }
}

export default Configurator;



// WEBPACK FOOTER //
// ./scripts/util/configurator.js